import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmLabel = "Delete",
  onConfirm,
  softDelete = false,
  linkedCount = 0,
}) => {
  const [reason, setReason] = useState("");
  useEffect(() => { if (open) setReason(""); }, [open]);

  const handleConfirm = () => onConfirm?.(reason);
  const desc = softDelete
    ? "This record will be moved to the Recycle Bin. An Administrator can restore it or permanently delete it later."
    : description;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-dialog" className="rounded-2xl border-[#E4E9F3]">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading text-[#14245F]">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-[#5A6B8C]">
            {desc}
            {softDelete && linkedCount > 0 && (
              <span className="mt-2 block font-medium text-[#A16207]">
                This record has {linkedCount} linked child record(s); they will be preserved but hidden until it is restored.
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {softDelete && (
          <div className="space-y-1.5">
            <Label className="text-xs text-[#5A6B8C]">Reason (optional)</Label>
            <Textarea
              data-testid="delete-reason-input"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why is this being removed?"
              className="min-h-[64px]"
            />
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" className="rounded-full border-[#E4E9F3]">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-delete"
            onClick={handleConfirm}
            className="rounded-full bg-[#DC2626] text-white hover:bg-[#B91C1C]"
          >
            {softDelete ? "Move to Recycle Bin" : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
